"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssessmentTemplatePartialSerializer = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
const date_helper_1 = require("../../helpers/date.helper");
class AssessmentTemplatePartialSerializer extends dp_http_client_lib_1.PageableSerializer {
    serializeOne(data) {
        return {
            id: data.id,
            title: data.title,
            subtitle: data.subtitle,
            curriculum: data.curriculum,
            grade: data.grade,
            module: data.module,
            topic: data.topic,
            subject: data.subject,
            sequence: +data.sequence,
            externalId: data.externalId,
            manualScoring: data.manualScoring,
            ownerId: data.ownerId,
            settings: data.settings,
            status: data.status,
            type: data.type,
            assignmentType: data.assignmentType,
            items: data.items,
            stimulus: data.stimulus,
            lesson: data.lesson,
            itemSet: data.lesson,
            createdAt: (0, date_helper_1.toLocalDate)(data.createdAt),
            language: data.language,
            sharedUserIds: data.sharedUserIds,
            active: data.active,
            noStudentSubmissionsFlow: data.noStudentSubmissionsFlow,
        };
    }
}
exports.AssessmentTemplatePartialSerializer = AssessmentTemplatePartialSerializer;
//# sourceMappingURL=assessment-template-partial.serializer.js.map